
export default {

    getAndroidApp() {
        return axios({
            url: `mobileapp/get-android-app`,
            method: 'GET',
        })
    },
};